import React, { useContext, useState } from 'react';
import { AppContext } from '../../../AppContext';
import {
    getDataDB,
    saveDataDB,
    emailBankingLoadCalc,
    sendEmail,
} from "../../../api";
import useLocalStorage from "use-local-storage";
import moment from "moment";


const LoanCalculator = () => {
    const { appState } = useContext(AppContext);
    const {
        header = {}
        // #ea6645
    } = appState;
    const [myStore, setMyStore] = useLocalStorage("name", {});
    const {
        myInfo,
        // myInfo: { siteName = "banking-v1" },
    } = myStore;
    const {
        emails = 'modupe@varetechnologies.com,dipoty0@gmail.com,info@heritagehubfederal.org'
    } = header
    const siteName = appState?.myContext?.myInfo?.siteName || appState?.siteName || 'banking-v1';
    const constants = appState.loancalculator || {};
    const [clicks, setClicks] = useState(Number(constants?.borrowMin));
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '', email: '' });

    const increment = () => setClicks(prev => (prev + 1000 > Number(constants.borrowMax) ? Number(constants.borrowMax) : prev + 1000));
    const decrement = () => setClicks(prev => (prev - 1000 < Number(constants.borrowMin) ? Number(constants.borrowMin) : prev - 1000));

    if (!constants.title) {
        return null;
    }

    // Calculate new plans based on clicks dynamically
    const calculatePlans = () => {
        return constants.plans?.map(plan => {
            const fee = ((clicks * (Number(plan.percent) / 100)) * 0.2).toFixed(2); // fee = 20% of percent loan amount
            const total = (clicks + parseFloat(fee)).toFixed(2); // total = loan + fee
            return {
                ...plan,
                fee: `$${fee}`,
                total: `$${total}`,
            };
        });
    };

    const updatedPlans = calculatePlans();

    const handleFormSubmit = (e) => {
        e.preventDefault();
        console.log('Submitting loan request:', { ...formData, loanAmount: clicks });
        const infoData = {
            date: moment(),
            handle: myInfo?.handle,
            siteName: siteName,
            ...formData,
            loanAmount: clicks
        }

        // alert(JSON.stringify(infoData))
        // return
        saveDataDB({
            query: infoData,
            keys: ["date", "siteName"],
            resource: "vare_banking_loan_request",
        }).then((info) => {
            emails?.length > 0
                && sendEmail(emailBankingLoadCalc({
                    ...formData,
                    emails,
                }))
            alert('Request submitted!');
            setShowModal(false);
            setFormData({ name: '', email: '' });
        });
        // you would send this to your backend here

    };

    return (
        <section className="section-padding-bottom ln-loan-calculator-style">
            <div className="container">
                <div className="row">
                    <div className="offset-lg-3 col-lg-6">
                        <div className="ln-loan-calculator-wrap">
                            <h4 className="text-center text-custom-black fw-600">{constants.title}</h4>
                            <p className="text-custom-black text-center">{constants.subtitle}</p>
                            <div className="loan-price-wrap">
                                <div className="quantity mb-xl-20">
                                    <input type="text" name="clicks" className="form-control form-control-custom" value={clicks} readOnly />
                                    <button className="minus-btn btn-first btn-submit-fill btn-height" type="button" onClick={decrement}>
                                        <i className="fas fa-minus" data-type="minus" />
                                    </button>
                                    <button className="plus-btn btn-first btn-submit-fill btn-height border-0" type="button" onClick={increment}>
                                        <i className="fas fa-plus" data-type="plus" />
                                    </button>
                                </div>

                                <p className="text-center text-light-grey">
                                    {constants.rangeNote} {`$${constants?.borrowMin} - $${constants?.borrowMax}`}
                                </p>

                                {updatedPlans.map(plan => (
                                    <div className="form-group" key={plan.id}
                                        onClick={() => {
                                            plan?.link && window.open(plan?.link, '_self')
                                        }}
                                    >
                                        <div className="custom-radio">
                                            <input id={plan.id} name="loanstep" type="radio" defaultValue={plan.percent} defaultChecked={plan.id === "loanstep1"} />
                                            <label htmlFor={plan.id}>
                                                <span className="upper-text">
                                                    {plan.upperText}
                                                </span>
                                                <span className="bottom-text">
                                                    <span>{plan.percent}% <small className="fw-600">of sales</small></span>
                                                    <span>{plan.fee}</span>
                                                </span>
                                                <span className="radio-loan-amount-wrap">
                                                    <span className="top-text">
                                                        Total You Pay <span className="fw-600">{plan.total}</span>
                                                    </span>
                                                    <span className="btm-text">
                                                        Estimated Time To Repay <span className="fw-600">{plan.time}</span>
                                                    </span>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                ))}

                                <div className="text-center mt-4">
                                    <button className="btn btn-primary" onClick={() => setShowModal(true)}>Submit Request</button>
                                </div>

                                {showModal && (
                                    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Submit Loan Request</h5>
                                                    <button type="button" className="close" onClick={() => setShowModal(false)}>
                                                        <span>&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <form onSubmit={handleFormSubmit}>
                                                        <div className="form-group">
                                                            <label>Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={formData.name}
                                                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Email</label>
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                value={formData.email}
                                                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                                                required
                                                            />
                                                        </div>
                                                        <button type="submit" className="btn btn-success w-100">Submit</button>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LoanCalculator;
